/** mss `curatorMyShop.clickGoodsLike` / `clickGoodsUnLike` 의 `product` 페이로드에 맞춤 */
export function mapProductItemToCurationLikeLog(product: {
  goodsNo: string | number;
  goodsName: string;
  price: number;
  salesRate?: number | null;
  brandName: string;
}) {
  const salesRate = product.salesRate != null ? product.salesRate : 0;

  return {
    product_id: String(product.goodsNo),
    product_name: product.goodsName,
    price: product.price,
    discount_rate: salesRate,
    brand_name: product.brandName,
  };
}
